module.exports = __webpack_public_path__ + "static/header-vertical-19388d3a25b76ab7142fa538fbb44c22.jpg";